import { call, put } from "redux-saga/effects";
import { prayerAndTalksConstants } from "../actions/constants/prayerAndTalksConstant";
import { exceptionHandler } from "../pages/common/functions";
import PrayerAndTalksService from "../services/api/prayerAndTalksService";

function* prayerAndTalksSave(request: any) {
	try {
		const result = yield call(
			PrayerAndTalksService.prayerAndTalksSave,
			request.input
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: prayerAndTalksConstants.prayerAndTalksSaveSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: prayerAndTalksConstants.prayerAndTalksSaveFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: prayerAndTalksConstants.prayerAndTalksSaveFailure,
			payload: error,
		});
	}
}

function* prayerAndTalksGetAllChannels() {
	try {
		const result = yield call(
			PrayerAndTalksService.prayerAndTalksGetAllChannels
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: prayerAndTalksConstants.prayerAndTalksGetChannelSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: prayerAndTalksConstants.prayerAndTalksGetChannelFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: prayerAndTalksConstants.prayerAndTalksGetChannelFailure,
			payload: error,
		});
	}
}

function* prayerAndTalksGetDetail(request: any) {
	try {
		const result = yield call(
			PrayerAndTalksService.prayerAndTalksGetDetail,
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: prayerAndTalksConstants.prayerAndTalksDetailSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: prayerAndTalksConstants.prayerAndTalksDetailFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: prayerAndTalksConstants.prayerAndTalksDetailFailure,
			payload: error,
		});
	}
}

export const prayerAndTalksSaga = {
	prayerAndTalksSave,
	prayerAndTalksGetAllChannels,
	prayerAndTalksGetDetail,
};